import { action } from '@ember/object';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import BaseRoute from './base-route.gjs';
import Component from '@glimmer/component';
import GhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import styles from './conversation-type-selection.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class MessagingRoutesConversationTypeSelection extends Component {
  @service alertManager;
  @service intl;
  @service messaging;
  @service messagingNavigation;

  get conversationTypes() {
    const prefix = `${this.intl.t('emc.conversation_type_selection.description_prefix')} `;

    return [
      {
        description: prefix + this.messaging.searchableContactsText,
        name: 'direct',
        icon: 'messaging-message',
        iconClass: 'direct-icon',
        title: this.intl.t('emc.conversation_type_selection.direct.title'),
      },
      {
        description: this.intl.t('emc.conversation_type_selection.group.description'),
        name: 'group',
        icon: 'messaging-group-practice',
        iconClass: 'group-icon',
        title: this.intl.t('emc.conversation_type_selection.group.title'),
      },
    ];
  }

  @action
  goBack() {
    this.messagingNavigation.toConversationList();
  }

  @action
  selectConversationType() {
    // Does the type change anything here? Perhaps we pass the type to contacts
    // so it knows what type of conversation to start?
    this.messagingNavigation.toContacts();
  }

  <template>
    <BaseRoute
      class="{{styles.component}} conversation-type-selection-page"
      data-test-conversation-type-selection-route
    >
      <:header>
        <GhostButton
          @fitContent={{true}}
          @iconOnly={{true}}
          {{on "click" this.goBack}}
          class="back-button"
          data-test-conversation-type-selection-page-back-button
        >
          {{svgJar "messaging-chevron-left"}}
        </GhostButton>

        <span class="title">{{t "emc.conversation_type_selection.title"}}</span>
      </:header>
      <:default>
        <div class="content" data-test-conversation-type-selection-page-content>
          <p class="instructions" data-test-instructions>
            {{t "emc.conversation_type_selection.instructions"}}
          </p>
          <div class="conversation-type-items">
            {{#each this.conversationTypes as |type|}}
              <button
                class="item"
                data-test-item={{type.name}}
                type="button"
                {{on "click" (fn this.selectConversationType type)}}
              >
                <div class={{type.iconClass}} data-test-icon>
                  {{svgJar type.icon}}
                </div>
                <div class="text">
                  <p class="title" data-test-title>{{type.title}}</p>
                  <p class="description" data-test-description>{{type.description}}</p>
                </div>
              </button>
            {{/each}}
          </div>
        </div>
      </:default>
    </BaseRoute>
  </template>
}
